export const ALL_ELEMENTS_TEXT = 'All Elements'
export const ALL_PROJECTS_ELEMENTS_TEXT = 'All Project Elements'
export const ADDED_TO_DRAFT = 'Added to Draft'
export const ADDED_TO_PROJECT = 'Added to Project'
export const PERSISTED_ELEMENT_ASSEMBLIES = 'persistedElementAssemblies'
export const PERSISTED_ELEMENT_DIVISIONS = 'persistedElementDivisions'
export const PREVIOUS_ADDEDTOPROJECT_PARENT_ASSEMBLIES =
    'previousAddedToProjectParentAssemblies'
export const PREVIOUS_ADDEDTOPROJECT_PARENT_DIVISIONS =
    'previousAddedToProjectParentDivisions'
export const PROJECTID_MASTERSPEC = 'MasterSpecProject'
export const PROJECTID_SPECTEXT = 'SpecTextProject'
